import React, { FC } from 'react';
import './DropdownSelect.scss';
import { BasicButton } from '../buttons/BasicButton/BasicButton';
import { ReactComponent as ArrowDropdown } from '../../../assets/images/arrows/ArrowDefault.svg';

interface DropdownSelectProps {
  handleLanguage: (selected: string) => void;
  availableLanguages: string[];
  selectedLanguage: string;
}

export const DropdownSelect: FC<DropdownSelectProps> = ({ handleLanguage, availableLanguages, selectedLanguage }) => {
  return (
    <div className="dropdown-select">
      <div className="dropdown-select__select-block">
        <div className="dropdown-select__select-block__selected-text">{selectedLanguage}</div>
        <ArrowDropdown className="dropdown-select__select-block__select-icon" />
      </div>
      <ul className="dropdown-select__select-options">
        {availableLanguages.map((item) => {
          return selectedLanguage !== item ? (
            <li className="dropdown-select__select-options__item" key={item}>
              <BasicButton
                handleClick={() => handleLanguage(item)}
                className="dropdown-select__select-options__item__btn"
              >
                {item}
              </BasicButton>
            </li>
          ) : null;
        })}
      </ul>
    </div>
  );
};
